import { useState, useEffect } from "react";
import { useFetchGetDataLangAgnostic } from "./useFetchData";
import { useQueryParams } from "./useLocationData";
import globalMapping from "../data/mapping/components/globalMapping";
import globalMockData from "../data/components/global-data.json";
import { supportedLanguages } from "./useLanguage";

const useFetchGlobalData = (language) => {
  // Laguage Set by configuration in path and key
  // to avoid caching between languages
  const isSpanish = language === supportedLanguages.es
  const queryKey = `globalData${language}`;
  const queryPath = `${isSpanish ? '/' + supportedLanguages.es : '' }/jsonapi/block_content?filter[field_json_component]=3`;

  // Mock Data support
  const queryParams =  useQueryParams();
  const isMockData = queryParams.get("useMockData") === "true";

  const [
    localeGlobalData,
    setLocaleGlobalData
  ] = useState("");

  // Fetches for specific global Language Data
  const {
    isLoading,
    error,
    data
  } = useFetchGetDataLangAgnostic(
    queryKey,
    queryPath,
    isMockData
  );

  // Might not need formatting
  useEffect(() => {
    if (data && !isMockData) {
      const mappedData = globalMapping(data);
      setLocaleGlobalData(mappedData)
    }
  }, [data, isMockData]);

  // mock data suppert
  if (isMockData) {
    return {
      error: false,
      isLoading: false,
      localeGlobalData: globalMockData
    };
  }

  return {
    error,
    isLoading,
    localeGlobalData
  };
};

export default useFetchGlobalData;
